export default __webpack_public_path__ + "static/media/LouverLevel2.721e1c75.svg";